module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/lake/Room_lake_03_layoutphoto_03.png";